(function($) {
	console.log( "mochi-theme.js" );

	$(document).ready(function() {
		var body = $('body');

		var burger = $('#header_burger');
		var header = $('#header_specificty_4the_win');
		var slideout = $('#mobile_slideout');
		var mobileMenu = $('#mochi_mobile_menu');

		burger.on('click', function(ev) {
			body.toggleClass('locked');
			burger.toggleClass('open');
			slideout.toggleClass('open');
		});

		function smooth_scroll_menu_item(ev, menuItem) {
			if ( body.hasClass('template-index') ) {
				var href = menuItem.attr('href');
				if ( typeof(href) == 'string' && href.length > 0 ) {
					if ( href.startsWith('/#') ) {
						href = href.substring(1);
					}
					if ( href.startsWith('#') ) {
						var target = $(href);
						if ( target.length ) {
							ev.preventDefault();
							var hdrHt = header.outerHeight();
							var tgtHt = target.offset().top;
							var offset = tgtHt - hdrHt;
							$('html,body').animate({ scrollTop: offset }, 600);
						}
					}
				}
			}
		}

		// header.find('.header__inline-menu .header__menu-item').on('click', function(ev) {
		// 	var menuItem = $(this);
		// 	smooth_scroll_menu_item(ev, menuItem)
		// });

		mobileMenu.find('.mochi-mobile-menu-link').on('click', function(ev) {
			var menuItem = $(this);
			burger.removeClass('open');
			slideout.removeClass('open');
			body.removeClass('locked');
			// smooth_scroll_menu_item(ev, menuItem);
		});

		function check_header_scrolling() {
			if ( body.hasClass('template-index') ) {
				if ( window.pageYOffset > 50 ) {
					header.addClass('mochi-white-bg');
				} else {
					header.removeClass('mochi-white-bg');
				}
			}
		}

		$(window).on('scroll', function(ev) {
			check_header_scrolling();
		});

		check_header_scrolling();

		if ( body.hasClass('template-collection') ) {
			var filtersForm = $('#FacetFiltersForm');

			function submit_collection_filtering() {
				console.log( "submit_collection_filtering()" );
				var url = filtersForm.data('action-url');
				var querySep = '?';
				filtersForm.find('input[type="checkbox"]').each(function(idx) {
					var checkboxInput = $(this);
					if ( checkboxInput.prop('checked') ) {
						var inputName = checkboxInput.attr('name');
						var inputValue = checkboxInput.val();
						url = url + querySep + inputName + '=' + inputValue;
						querySep = '&';
					}
				});
				var sortBy = $('#SortBy').val();
				url = url + querySep + 'sort_by=' + sortBy;
				window.location = url;
				// NOTE
				// I am at a complete loss to explain why setting window.location
				// works, but submitting the form causes the sort_by parameter to
				// get completely stripped upon submit(). Would love to know why!
				// filtersForm.attr('action', url);
				// setTimeout(function() {
				// 	filtersForm.submit();
				// }, 5000);
			}

			$('#SortBy').on('change', function(ev) {
				submit_collection_filtering()
			});
			filtersForm.find('input[type="checkbox"]').on('change', function(ev) {
				submit_collection_filtering()
			});

			$('#mobile_product_slideout_control').on('click', function(ev) {
				$('#main-collection-filters').addClass('open');
				body.addClass('locked');
			});
			$('#mochi_sidebar_closer').on('click', function(ev) {
				$('#main-collection-filters').removeClass('open');
				body.removeClass('locked');
			});
		}

		if ( body.hasClass('template-product') ) {
			var singleProductSwiper = new Swiper('#single_product_swiper', {
				spaceBetween: 10
			});

			var thumbsDiv = $('#single_product_thumbs');
			var thumbWrap = thumbsDiv.find('.single-product-thumbnail-wrapper');
			if ( thumbWrap[0].scrollWidth <= thumbWrap[0].clientWidth ) {
				thumbsDiv.addClass('not-scrollable');
			}

			$('.mochi-product-gallery').on('click', '.single-product-thumbnail', function(ev) {
				var imageIdx = $(this).data('image-idx');
				$(this).parent().find('.single-product-thumbnail').removeClass('active');
				$(this).addClass('active');
				singleProductSwiper.slideTo( imageIdx );
			});

			$('.mochi-product-options.option-button').on('click', '.mochi-option-btn', function(ev) {
				var optionBtn = $(this);
				var optionsWrap = optionBtn.parent();
				optionsWrap.find('.mochi-option-btn').removeClass('selected');
				optionBtn.addClass('selected');
				adjust_variant_selection();

				if ( optionsWrap.hasClass('option-size') ) {
					var optionValue = optionBtn.data('option-value');
					$('#option_size_label').text(optionValue);
				}
			});

			$('.mochi-product-options.option-color').on('click', '.mochi-color-btn', function(ev) {
				var optionBtn = $(this);
				var optionsWrap = optionBtn.parent();
				optionsWrap.find('.mochi-color-btn').removeClass('selected');
				optionBtn.addClass('selected');
				adjust_variant_selection();

				var optionValue = optionBtn.data('option-value');
				var optionColor = optionBtn.data('option-color');
				var borderStyle = optionBtn.data('option-border');
				$('#option_color_label').text(optionValue);
				$('#option_size_box').css('background-color', optionColor);
				if ( borderStyle == 'dark' ) {
					$('#option_size_box').css('border-color', '');
				} else {
					$('#option_size_box').css('border-color', optionColor);
				}
			});

			// I apologize for not having the time to make this code "specific options dependent".
			// The more general approach would use the "option1", "option2", etc. to to this generically.
			
			function adjust_variant_selection() {
				var selectedColor = $('.mochi-product-options.option-color .mochi-color-btn.selected');
				var selectedSize = $('.mochi-product-options.option-button .mochi-option-btn.selected');

				var disableIt = true;
				var sizeOption = selectedSize.data('option-name');
				var sizeValue = selectedSize.data('option-value');
				var colorOption = selectedColor.data('option-name');
				var colorValue = selectedColor.data('option-value');
				for ( let idx = 0 ; idx < gFDProductVariantData.length ; idx++ ) {
					var variantData = gFDProductVariantData[idx];
					if ( variantData[sizeOption] == sizeValue && variantData[colorOption] == colorValue ) {
						$('#product_form input[name="id"]').val( variantData.id );
						$('#product_price_wrap').html( variantData.price_html );
						var skuText = variantData.sku;
						if ( skuText.length < 1 ) {
							skuText = '&nbsp;';
						}
						$('#product_sku').html( skuText );
						if ( variantData.available ) {
							disableIt = false;
						}
						// Scroll to variant image, if available
						var findPath = 'div[data-variant-id="' + variantData.id + '"]';
						var newActive = $('#single_product_thumbs').find(findPath);
						if ( newActive.length ) {
							var thumb = $('#single_product_thumbs .single-product-thumbnail').removeClass('active');
							newActive.addClass('active');
							var imageIdx = newActive.data('image-idx');
							singleProductSwiper.slideTo( imageIdx );
						}
					}
				}
				$('#product_submit_btn').prop('disabled', disableIt);
				return;

				var disableIt = true;
				if ( $('input[name="variation_id"]').length == 0 ) {
					// SIMPLE PRODUCT
					var disableIt = false;
				} else if ( typeof(sizeSlug) == 'string' && sizeSlug.length && typeof(colorSlug) == 'string' && colorSlug.length ) {
					// VARIABLE PRODUCT
					var variationMnemonic = sizeSlug + '|' + colorSlug;
					variationInfo = gOCSingleProductVariations[variationMnemonic];
					// console.log( "VARIANTINFO[" + variationMnemonic + "] ", variationInfo );

					// This hidden input is submitted with the form, and without it you will fail
					$('input[name="variation_id"]').val( variationInfo.id );

					$('#product_price_html').html( variationInfo.price );

					if ( variationInfo.in_stock ) {
						disableIt = false;
					}

					var stockText = '';
					if ( variationInfo.max_qty < 1 ) {
						stockText += '<span class="out-of-stock-text">';
					}
					stockText += '(在庫：';
					stockText += (variationInfo.max_qty < 1 ? '在庫切れ' : variationInfo.max_qty);
					stockText += ')';
					if ( variationInfo.max_qty < 1 ) {
						stockText += '</span>';
					}
					$('#price_variation_stock').html(stockText);

					$('input[name="quantity"]').attr('max', variationInfo.max_qty);

					if ( variationInfo.image_url.length && variationInfo.thumb_url.length ) {
						$('#product_main_image_slide').addClass('loading');
						$('#product_main_thumb_slide').addClass('loading');
						$('#single_product_thumbs .single-product-thumbnail-wrapper').removeClass('animate__animated animate__bounce');
						$('#product_main_image_slide .single-product-single-image').attr('src', variationInfo.image_url);
						$('#product_main_thumb_slide .single-product-thumbnail-image').attr('src', variationInfo.thumb_url);
					}

					$('#product_price_html .woocommerce-Price-amount').addClass('animate__animated animate__bounce');
				}

				$('button[type="submit"]').prop('disabled', disableIt);
			}
		}
		if ( body.hasClass('page-user-guide') ) {
			$('.mochi-guide-nav-button:not(.new-page)').on('click', function(ev) {
				ev.preventDefault();
				var link = $(this);
				console.log( "LINK: ", link );
				var anchor = link.attr('href');
				console.log( "ANCHOR: '" + anchor + "'" );
				var anchorTop = $(anchor).offset().top;
				console.log( "TOP: " + anchorTop );
				var headerHt = $('#header_specificty_4the_win').height();
				$('html, body').animate({
					scrollTop: (anchorTop - (headerHt + 30))
				}, 'slow');
			})
		}
		var links = document.links;
		for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
		}
	});
})(jQuery);
